export default "__VITE_ASSET__ZPTwxvvY__"